import { LoginProvider } from '$providers/login';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { validarCpf } from '../../../../util/cpfutil';
import { RecoveryPasswordCodePage } from '../recovery-password-code/recovery-password-code';

@Component({
  selector: 'page-recovery-password-request',
  templateUrl: 'recovery-password-request.html',
})
export class RecoveryPasswordRequestPage {

  public cpf: any;

  constructor(private navCtrl: NavController, navParams: NavParams, private loginProvider: LoginProvider,
    private viewProvider: ViewProvider) {

    this.cpf = navParams.get('cpf');
  }

  public submit() {
    if (!this.validate()) {
      this.viewProvider.showMessage('- <b>CPF</b> inválido.');
      return;
    }

    this.loginProvider.requestPasswordRecovery(this.cpf).subscribe(
      (dispNotificados) => {
        if (dispNotificados) {
          let message = 'Código de recuperação de senha foi enviado para: <br>';
          dispNotificados.forEach((d) => { message += '- ' + d + ';<br>' });
          this.viewProvider.showMessage(message, () => {
            this.navCtrl.push(RecoveryPasswordCodePage, { cpf: this.cpf, dispNotificados: dispNotificados });
          });
        }
      },
      (error) => { console.error(error.message) }
    );
  }

  private validate(): boolean {
    let valido = true;
    validarCpf(this.cpf, (msg) => valido = false);
    return valido;
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/recovery-password/recovery-password-request/recovery-password-request.ts